module.exports = __webpack_public_path__ + "static/media/twitter.ce7b4039.svg";